export const state = {
  items: [],
  headerItems: [],
};
